import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Utilities } from "./utilities";

@Injectable()
export class LivestreamService {

  public action = "edit";

  constructor(
    private afdb: AngularFireDatabase,
    private utilities: Utilities,
  ) { }

  public getLivestreamList(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Livestream`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Livestream`;
    }
    return this.afdb.list<any>(ref).valueChanges();
  }

  public getLivestreamItem(clientId: string, livestreamId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Livestream/${livestreamId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Livestream/${livestreamId}`;
    }
    return this.afdb.object<any>(ref).valueChanges();
  }

  public createOrEditlivestream(clientId: string, livestreamInfo: any) {
    if (!livestreamInfo.id) {
      livestreamInfo.id = this.utilities.generateRamdomKey();
      this.action = "create";
    }

    let ref = `Clients/${clientId}/Interactivity/Livestream/${livestreamInfo.id}`;
    if (this.utilities.validateEventIdParam(livestreamInfo.eventId)) {
      ref = `Clients/${clientId}/Event/${livestreamInfo.eventId}/Livestream/${livestreamInfo.id}`;
    }

    return new Promise((res, rej) => {
      this.afdb.database
        .ref(ref)
        .set(livestreamInfo)
        .then(() => {
          return res(livestreamInfo.id);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/livestream.service.ts